export const domain = 'https://api.themoviedb.org/3'
export const imageBasePath = 'https://image.tmdb.org/t/p/original'

export const aPI = process.env.REACT_APP_TMDB_KEY
